(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('CloudPBXPrefixDeleteController',CloudPBXPrefixDeleteController);

    CloudPBXPrefixDeleteController.$inject = ['$uibModalInstance', 'entity', 'CloudPBXPrefix'];

    function CloudPBXPrefixDeleteController($uibModalInstance, entity, CloudPBXPrefix) {
        var vm = this;

        vm.cloudPBXPrefix = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CloudPBXPrefix.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
